import Hallow from "hallow";
import './index.css';
import {Redirect} from "react-router-dom";

class SharedSample extends Hallow.HallowComponent {
    componentDidMount() {
        if (!this.state.prayer) {
            const {prayerId} = this.props.match.params;
            this.getAPI('prayers', prayerId).then((prayerData) => {
                this.setState({prayer: prayerData});
            }, (failureReason) => {
                this.setState({failed: failureReason, prayer: null});
            });
        }
    }

    render() {
        if(this.state.failed) {
            return <Redirect {...this.generateKeyProps('failRedirect')} to='/404'/>
        } else if (this.state.prayer) {
            const {prayerId} = this.props.match.params;

            return (<div style={{position: 'relative'}}>
                <div className='backgroundImage' style={{backgroundImage: 'url(' + this.state.prayer.image_url + ')'}} />
                <div className='App singlePrayer' key={this.generateChildKey('sampleWrapper')}>
                    <Hallow.Prayer {...this.generateKeyProps('p' + prayerId + '_prayer')} id={prayerId} type='sample' usePublic={this.props.usePublic} />
                    <div className='joinLinks' key={this.generateChildKey('joinLinks')}>
                        <div className='experience' key={this.generateChildKey('experience')}>Experience the full app!</div>
                        <br/>
                        <a href="https://hallow.onelink.me/Q25Y/prayershare" key={this.generateChildKey('registerLink')}>
                            <button className='joinButton' key={this.generateChildKey('registerButton')}>Create a Free Account</button>
                        </a>
                    </div>
                </div>
            </div>);
        } else {
            return null;
        }
    }
}

export default SharedSample;